//该文件用于创建Vuex中最为核心的store

//引入Vue
import Vue from 'vue';
//引入Vuex
import Vuex from 'vuex';//引入插件并使用插件
Vue.use(Vuex); //使用插件后就可以在vm,vc里使用store配置项

// 本地开发/首次启动时，保证 localStorage 里有可用的 baseURL，避免接口层拼接出错
const ensureBaseURL = () => {
    const existing = localStorage.getItem('baseURL');
    if (existing) return;

    // 生产默认指向线上；开发时可通过 localStorage 手动覆盖，或配置 VUE_APP_BASE_URL
    const fallback =
        process.env.NODE_ENV === 'development'
            ? (process.env.VUE_APP_BASE_URL || 'http://localhost:3000')
            : (process.env.VUE_APP_BASE_URL || 'https://bgjk.jxdinfen.com');

    localStorage.setItem('baseURL', fallback);
};
ensureBaseURL();

//准备actions,用于响应组件中的动作
const actions = {
    updateGlobalVar({ commit }, newValue) {
        commit('updateGlobalVar', newValue);
    }
};

//准备mutations,用于操作数据(state)
const mutations = {
    updateGlobalVar(state, newValue) {
        let baseURL;
        if (newValue == 0) {
            baseURL = process.env.VUE_APP_BASE_URL || "http://localhost:3000";
        } else if (newValue == 1) {
            baseURL = "https://buguangym.jxdinfen.com";
        } else if (newValue == 2) {
            baseURL = "https://bgjk.jxdinfen.com";
        }
        state.globalVar = baseURL;
        localStorage.setItem('baseValue', newValue);
        localStorage.setItem('baseURL', baseURL);
    }
};

//准备state,用于存储数据
const state = {
    globalVar: "https://bgjk.jxdinfen.com"
};

//创建store
const store = new Vuex.Store({
    actions: actions,
    mutations, //简写
    state //简写
});

//导出store
export default store;

